import React from "react";
import { Search } from "lucide-react";

const ReturnRequests = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8 lg:p-12">
      {/* Header */}
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6">
        Return requests
      </h1>

      {/* Search Section */}
      <div className="bg-white rounded-2xl shadow-md p-6 mb-8">
        <div className="flex items-center mb-4">
          <Search className="text-gray-600 mr-2" size={22} />
          <h2 className="text-lg font-medium text-gray-700">Search</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left side fields */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center">
              <label className="text-gray-700 font-medium w-40">Start date</label>
              <input
                type="date"
                className="mt-2 sm:mt-0 flex-1 border rounded-lg p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center">
              <label className="text-gray-700 font-medium w-40">End date</label>
              <input
                type="date"
                className="mt-2 sm:mt-0 flex-1 border rounded-lg p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
          </div>

          {/* Right side fields */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center">
              <label className="text-gray-700 font-medium w-40">ID</label>
              <input
                type="text"
                placeholder="Enter ID"
                className="mt-2 sm:mt-0 flex-1 border rounded-lg p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center">
              <label className="text-gray-700 font-medium w-40">Return status</label>
              <select className="mt-2 sm:mt-0 flex-1 border rounded-lg p-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400">
                <option>All</option>
                <option>Pending</option>
                <option>Approved</option>
                <option>Rejected</option>
              </select>
            </div>
          </div>
        </div>

        {/* Search Button */}
        <div className="mt-6 flex justify-center">
          <button className="flex items-center bg-blue-500 text-white font-medium px-6 py-3 rounded-xl hover:bg-blue-600 transition">
            <Search className="mr-2" size={20} /> Search
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-2xl shadow-md p-6">
        <p className="text-gray-600 mb-4">
          The Return Request feature (RMA) enables customers to send products back to you.
          Here you can find all submitted return requests. Learn more about{" "}
          <a href="#" className="text-blue-500 hover:underline">
            return requests
          </a>
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm text-gray-700">
            <thead className="bg-gray-100 text-gray-800">
              <tr>
                <th className="px-4 py-3 border">ID</th>
                <th className="px-4 py-3 border">Product</th>
                <th className="px-4 py-3 border">Quantity</th>
                <th className="px-4 py-3 border">Quantity returned to stock</th>
                <th className="px-4 py-3 border">Customer</th>
                <th className="px-4 py-3 border">Order #</th>
                <th className="px-4 py-3 border">Return request status</th>
                <th className="px-4 py-3 border">Date</th>
                <th className="px-4 py-3 border">Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan="9"
                  className="text-center py-6 text-gray-500 border"
                >
                  No data available in table
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center mt-4 text-gray-600 text-sm gap-2">
          <div className="flex items-center gap-2">
            <button className="px-3 py-1 border rounded-md bg-gray-50 hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 border rounded-md bg-blue-500 text-white">
              1
            </button>
            <button className="px-3 py-1 border rounded-md bg-gray-50 hover:bg-gray-100">
              Next
            </button>
          </div>
          <div className="flex items-center gap-2">
            <span>Show</span>
            <select className="border rounded-lg p-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>
        </div>

        <div className="text-center text-gray-400 mt-2">No records</div>
      </div>
    </div>
  );
};

export default ReturnRequests;
